module.exports = __webpack_public_path__ + "static/media/thumbnail_play_yellow.bbdfbf49.svg";